import React, { useContext } from 'react'

const ScreenLoaderContext = React.createContext()

export const useScreenLoader = () => {
  const {
    screenLoaded,
  } = useContext(ScreenLoaderContext)

  return {
    screenLoaded,
  }
}

export default ScreenLoaderContext
